<template>
<Modal 
    :id="'cmp_bookings_booking_add_artist'"
    @cancelled="onCancelClick"  
>
    <template slot="header">
        <template> Account All </template>
        
    </template>
    <template slot="body">
        <div >
         
            <p> Do you want to account all lines with status 'Account Recoupables' ?  </p>

            <p style="color:var(--sprt-5);">Optional</p>
            <TextField
              class="m1"
            
              type="date"
              :id="'balance_date'"
              v-bind="textFieldConfig"
              :value="balance_date"
              :placeholder="$dft.capHead($t('account_date'))"
              @valuechanged="onTextFieldValueChange"
            
            
            ></TextField>
        </div>

     </template>
    <template slot="options">
        <button class="dt-button s7 " @click="onCancelClick">Cancel</button>
        <button   class="dt-button s7 v1" @click="onOKClick">OK</button>
        
    </template>
</Modal>
  
  
</template>

<script>
import Modal from '../../../../dt-plugins/modal/modal';

import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";

import InputField from "@plugins/text-field/input-field";


import ModalContainer from "@dtplugins/modal/modal-container";
import { recoupableService } from '../../services/recoupable-service';




export default {
  props: {
    filter: {
      type: Object
    }
  },
  components: {
    
    Modal,
    NTable,
    InputField,
    DTIconButton,
    ModalContainer,
   
    //AdvanceSearch,
   
  },
  mounted:async  function () {
    // await recoupableService.autoFetchForAllContracts();
    console.log(this.filter,"this.filter");
        
  },
  data: function () {
    return {
     textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        immediateValidation: false,
      },
       balance_date:'',
    
    };
  },
   mixins: [],

  computed: {
    recoupableAccountId:function(){
      return this.$route.query.recoupableAccountId
    }
    
  },
  methods: { 
    onCancelClick: function() {
      this.$emit("cancelled", true);
    },

    
     onTextFieldValueChange: function (name, value) {    
      this[name]=value;

      // this.selectedProductMedia = {
      //   ...this.selectedProductMedia,
      //   [name]: value,
      // };
    },

    onOKClick:async function(){
      console.log(this.$route.query.recoupableAccountId);
      // if(this.recoupableAccountId.length>0){
      //   const dataRes =await recoupableService.accountAllRecoupables(this.balance_date,this.recoupableAccountId);
      //   console.log("dataRes" ,dataRes);
      // }

      await recoupableService.accountAllRecoupablesV2({...this.filter.basicFilter,...this.filter.searchFilter,balance_date:this.balance_date});
      this.$emit("accountAll",true)        
      this.onCancelClick();
    }
  
  },
};
</script>

<style lang="scss">
.cmp-catalog-releases-releases_list {
  .dt-page--body {
    --offset: 190px;
  }
  td.file_name a {
  }
  .dt-page--data-table {
    --offset: 135px;
  }
  .dt-page--top-bar {
    .input-field-container {
      max-width: 128px;
    }
  }
  //   .invoicelist-footer {
  //   border-top: 1px solid var(--sprt-5);

  //   .invoice_status_list {
  //     display: flex;
  //     .status {
  //       margin-top: 15px;
  //       display: flex;
  //       // max-width: 150px;
  //       flex: 0.5;
  //       .circle {
  //         width: 15px;
  //         height: 15px;
     
  //         margin-right: 10px;
  //         margin-top: 2.5px;
  //       }
  //       .status-name {
  //         flex: 1;
  //       }
  //     }
  //   }
  // }
}
</style>